import { createFileRoute, redirect } from '@tanstack/react-router';

// eslint-disable-next-line
export const Route = createFileRoute('/*')({
  loader: undefined,
  beforeLoad: () => {
    throw redirect({
      from: '/*',
      to: '/',
    });
  },
});
